import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";

import { Button } from "components/atoms/button/index";
import { Fields } from "./constants";
import { Header } from "components/atoms/header/index";
import * as S from "./resend-activation.styles";
import { Field } from "components/molecules/Field";
import { UserService } from "core/service/user.service";

export const ResendActivationCode = () => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  const onSubmit = (values) => {
    UserService.resendActivationCode(values);
  };

  return (
    <div>
      <Header company="simpletax" />
      <S.Container>
        <S.CardHeader>{t("activationCode.header")}</S.CardHeader>
        <S.CardBody>
          <S.Form onSubmit={handleSubmit(onSubmit)}>
            {Fields.map((obj, index) => (
              <Field
                background="grey"
                labelcolor="light"
                {...obj}
                register={register}
                error={errors[obj.name]?.message}
                key={index}
              />
            ))}
            {/* todo: playstore and appstore link to be included */}
            <S.ButtonContianer>
              <Button value={t("activationCode.button")} />
            </S.ButtonContianer>
          </S.Form>
        </S.CardBody>
        <S.CardFooter>
          <S.RegisterWrap>
            <Link to="/">{t("activationCode.footer")}</Link>
          </S.RegisterWrap>
        </S.CardFooter>
      </S.Container>
    </div>
  );
};
